module.exports = __webpack_public_path__ + "img/max_isack_home.d6c9d17a.png";